import { UntypedFormControl, ValidationErrors } from '@angular/forms';

export class CustomValidators {

  static validatorOnlyNumber(control: UntypedFormControl): ValidationErrors | null {
    const value = control.value?.trim();

    if (/^[\d\s]+$/.test(value)) {
      return { valueOnlyNumberError: true };
    }

    return null;
  }


  static validatorCurrencyZero(control: UntypedFormControl): ValidationErrors | null {
    if (control.value == "0.00") {
      return { valueZeroError: true };
    }
    return null;
  }

  static validatorNroProcesso(control: UntypedFormControl): ValidationErrors | null {
    const value = control.value;
    if (!value) {
      return { valueEmptyError: true };
    }

    // Verifica se o valor é um número e tem exatamente 20 dígitos
    if (!/^\d{20}$/.test(value)) {
      return { valueFormatError: true };
    }

    return null;
  }
}
